<template>
  <div>
    <div class="app-title">
      <em-view-title :crudState="$_emCommonListMixin_pathType"></em-view-title>
    </div>
    <section class="app-content" v-menu-permission="'list'">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div
            id="collapseOne"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordionFilter"
          >
            <div class="card-body">
              <form>
                <em-filter
                  :entity="modelName"
                  ref="emListFilter"
                  query-api="receive101Query"
                  $_em-custom-vuex-mixin_vo="receive101Vo"
                  $_em-custom-vuex-mixin_filter="receive101Filter"
                  @showEntityModalSelect="
                    $_emCommonModalMixin_showModalSelectorByFilter
                  "
                ></em-filter>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="sithMesInventoryItemResultTable" class="content">
        <div class="card my-1">
          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <em-table
                :entity="modelName"
                withCustomRowActions
                $_em-custom-vuex-mixin_vo="receive101Vo"
                $_em-custom-vuex-mixin_filter="receive101Filter"
                ref="emTable"
                query-api="receive101Query"
                exportDisabled
                :inlineActionsDisabled="prop_inline !== '1'"
                editDisable
                @showModalSelectorByNewRow="
                  $_emCommonModalMixin_showModalSelectorByNewRow
                "
                @showModalSelectorByEditRow="
                  $_emCommonModalMixin_showModalSelectorByEditRow
                "
              >
              <template #left-header>
                <b-button
                    variant="outline-primary"
                    size="sm"
                    @click="receiveItem()"
                  >
                    扫码101
                </b-button>
                <b-button
                    variant="outline-primary"
                    size="sm"
                    @click="returnItem()"
                  >
                    扫码102
                </b-button>
                <b-button
                    variant="outline-primary"
                    size="sm"
                    :disabled="actionDisabled('select')"
                    @click="openBatchReceive()"
                  >
                    手动101
                </b-button>
                <b-button
                    variant="outline-primary"
                    size="sm"
                    :disabled="actionDisabled('select')"
                    @click="openBatchReturn()"
                  >
                    手动102
                </b-button>
                <b-button
                    variant="outline-primary"
                    size="sm"
                    :disabled="actionDisabled('selectOne')"
                    @click="createAbnormalArrivalProcess()"
                  >
                    发起异常到货
                </b-button>
              </template>
              </em-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <em-modal-entity-selector
      ref="emModalEntitySelector"
    ></em-modal-entity-selector>

    <el-dialog title="101收货" :visible.sync="receiveDialogVisible" :close-on-click-modal='false' append-to-body @close='clearItemList'>
      <el-table :data="itemList" style="width:100%" max-height="285px" empty-text="请点击打开扫码框扫码">
        <el-table-column label="PO" fixed prop="purchaseNumber"></el-table-column>
        <el-table-column label="ITEM" prop="itemCode"></el-table-column>
        <el-table-column label="类别" prop="category"></el-table-column>
        <el-table-column label="名称" prop="materielName"></el-table-column>
        <el-table-column label="单位" prop="materielUnit"></el-table-column>
        <el-table-column prop="urgency" label="紧急程度">
          <template slot-scope="scope">
              {{getUrgencyName(scope.row.urgency)}}
          </template>
        </el-table-column>
        <el-table-column prop="taxFlag" label="免税标记">
          <template slot-scope="scope">
              {{getTaxFlagName(scope.row.taxFlag)}}
          </template>
        </el-table-column>
        <el-table-column label="到货数量" prop="arrivedQuantity"></el-table-column>
        <el-table-column label="累计101" prop="receiptQuantity"></el-table-column>
        <el-table-column label="本次101数量">
            <template slot-scope="scope">
                <el-input clearable v-model="scope.row.currentQuantity" size="small"></el-input>
            </template>
        </el-table-column>
      </el-table>
        <el-dialog title="扫一扫" :center="true" :visible.sync="openScanner" append-to-body @close="closeScannerDialog"
                   :close-on-click-modal='false'>
        <qr-code-scanner ref="scanner" @getCodeData='getCodeData'>
        </qr-code-scanner>
      </el-dialog>
      <div slot="footer" class="dialog-footer">
        <el-button @click="receiveDialogVisible = false">取 消</el-button>
        <el-button @click="openScannerDialog()">打开扫码框</el-button>
        <!-- <el-button @click="createAbnormalArrivalProcess()" :disabled="itemList.length == 0">发起异常</el-button> -->
        <el-button @click="submit101Inspection()" :disabled="itemList.length == 0">发起质检</el-button>
        <el-button type="primary" @click="batchReceive101()" :disabled="itemList.length == 0">确认收货</el-button>
      </div>
    </el-dialog>

    <el-dialog title="102退货" :visible.sync="returnDialogVisible" :close-on-click-modal='false' append-to-body @close='clearQuantity'>
      <el-table :data="receiveRecords" ref="recordTable" style="width:100%" max-height="285px" @selection-change="handleSelect">
        <el-table-column type="selection" width="30"></el-table-column>
        <el-table-column label="PO" fixed prop="poNumber"></el-table-column>
        <el-table-column label="ITEM" prop="itemCode"></el-table-column>
        <el-table-column label="收货数量" prop="receiptQuantity"></el-table-column>
        <el-table-column label="已退数量" prop="returnQuantity"></el-table-column>
        <el-table-column label="凭据号" prop="credential"></el-table-column>
        <el-table-column label="101时间" prop="operateTime"></el-table-column>
        <el-table-column label="本次102数量">
            <template slot-scope="scope">
                <el-input clearable v-model="scope.row.currentReturn" size="small"></el-input>
            </template>
        </el-table-column>
      </el-table>
        <el-dialog title="扫一扫" :center="true" :visible.sync="openScanner" append-to-body @close="closeScannerDialog"
                   :close-on-click-modal='false'>
        <qr-code-scanner ref="scanner" @getCodeData='getRecord101Data'>
        </qr-code-scanner>
      </el-dialog>
      <div slot="footer" class="dialog-footer">
        <el-button @click="returnDialogVisible = false">取 消</el-button>
        <el-button @click="openScannerDialog()">打开扫码框</el-button>
        <el-button type="primary" @click="batchReturn102New()" :disabled="itemList.length == 0">确认退货</el-button>
      </div>
    </el-dialog>

    <el-dialog title="批量101收货" :visible.sync="batchDialogVisible" :close-on-click-modal='false' append-to-body @close='clearItemList'>
      <el-table :data="itemList" ref="batchTable" style="width:100%" max-height="285px">
        <!-- <el-table-column type="selection" width="30"></el-table-column> -->
        <el-table-column label="PO" fixed prop="purchaseNumber"></el-table-column>
        <el-table-column label="ITEM" prop="itemCode"></el-table-column>
        <el-table-column label="类别" prop="category"></el-table-column>
        <el-table-column label="名称" prop="materielName"></el-table-column>
        <el-table-column label="单位" prop="materielUnit"></el-table-column>
        <el-table-column label="到货数量" prop="arrivedQuantity"></el-table-column>
        <el-table-column label="累计101" prop="receiptQuantity"></el-table-column>
        <el-table-column label="本次101数量">
            <template slot-scope="scope">
                <el-input clearable v-model="scope.row.currentQuantity" size="small"></el-input>
            </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="batchReceive101()">确认收货</el-button>
      </div>
    </el-dialog>

    <el-dialog title="批量102" :visible.sync="batchReturnDialogVisible" :close-on-click-modal='false' append-to-body @close='clearQuantity'>
      <el-table :data="receiveRecords" ref="recordTable" style="width:100%" max-height="285px" @selection-change="handleSelect">
        <el-table-column type="selection" width="30"></el-table-column>
        <el-table-column label="PO" fixed prop="poNumber"></el-table-column>
        <el-table-column label="ITEM" prop="itemCode"></el-table-column>
        <el-table-column label="收货数量" prop="receiptQuantity"></el-table-column>
        <el-table-column label="已退数量" prop="returnQuantity"></el-table-column>
        <el-table-column label="凭据号" prop="credential"></el-table-column>
        <el-table-column label="101时间" prop="operateTime"></el-table-column>
        <el-table-column label="本次102数量">
            <template slot-scope="scope">
                <el-input clearable v-model="scope.row.currentReturn" size="small"></el-input>
            </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="batchReturn102New()">确认102</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
// Author Lin
// Date 2021-04-21 11:22:06

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";
import qrCodeScanner from "@/components/QRCode/QRCodeScannerForInventory"

export default {
  components: { qrCodeScanner },
  name: "sithMesInventoryItemListView",
  mixins: [emCommonListMixin,emCommonApiMixin,qrCodeScanner],
  props: {
    //是否启用行编辑
    prop_inline: {
      type: String,
      default: "0",
    },
  },
  data() {
    return {
      receiveDialogVisible: false,
      returnDialogVisible: false,
      openScanner: false,
      itemList: [],
      quantityForm: {
        receivedQuantity:"",
      },
      returnQuantityForm: {
        returnQuantity:"",
      },
      batchDialogVisible:false,
      batchReturnDialogVisible: false,
      receiveRecords: []
    }
  },
  computed: {
    modelName() {
      return "sithMesInventoryItem"
    },
    checkedItems() {
      //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
      return this.$store.state[this.modelName]["checkedItemsReceive101Vo"];
      // return this.$refs.emTable.checkedItems
    },
    selectIds() {
      //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
      return this.$store.state[this.modelName]["checkedItemsReceive101Vo"].join(",");
    },
  },
  methods: {
    actionDisabled(type) {
      // 删除按钮在一条记录都没选的时候禁用
      if (type === "select") {
        // return this.$refs.emTable.checkedItems && this.$refs.emTable.checkedItems.length === 0;
        return this.checkedItems && this.checkedItems.length === 0;
      }
      // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
      else if (type === "selectOne") {
        // return this.$refs.emTable.checkedItems && this.$refs.emTable.checkedItems.length !== 1;
        return this.checkedItems && this.checkedItems.length !== 1;
      }
    },
    receiveItem() {
      this.receiveDialogVisible = true;
    },
    returnItem() {
      this.returnDialogVisible = true;
    },
    clearItemList() {
      this.itemList = [];
      this.quantityForm.receivedQuantity = '';
      this.returnQuantityForm.returnQuantity = '';
    },
    closeScannerDialog() {
      this.$refs.scanner.closeCamera();
      this.$refs.scanner.resetOutputData();
      this.openScanner = false;
    },
    // 用于101收货时，根据扫码信息查询对应的PO-ITEM，扫码收货单次只支持一个物料
    getCodeData(data) {
      console.log("get qr code data:"+data);
      this.openScanner = false;
      let self = this;
      //检验二维码的数据格式
      try {
        var obj = JSON.parse(data);
        var poNumber = obj.PO;
        var item = obj.PoItem;
        console.log(poNumber);
        console.log(item);
      } catch (error) {
        self.$message({
          message: "无效的二维码",
          type: "error",
        });
        return;
      }

      let _url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryItem")}/`;
      _url += `checkIfNotReceived?poNumber=${poNumber}&item=${item}&type=101`;
      this.$_emApiMixin_get(_url, {})
        .then((value) => {
          var arr = Object.keys(value);
          if (arr.length != 0) {
            console.log("value======"+JSON.stringify(value));
            // 扫码收货每次只支持收一个，所以新扫码结果会覆盖旧的
            self.itemList = [];
            self.itemList.push(value);
            self.$message({
              message: "扫码成功",
              type: "success",
            });
          } else {
            self.$message({
              message: "无对应物料或物料已收货",
              type: "error",
            });
          }
        })
        .finally(() => {
          this.openScanner = false;
        });
    },
    // 用于102退货，根据扫码信息查询对应POITEM的所有101收货记录
    getRecord101Data(data) {
      console.log("get qr code data:"+data);
      this.openScanner = false;
      let self = this;
      //检验二维码的数据格式
      try {
        var obj = JSON.parse(data);
        var poNumber = obj.PO;
        var item = obj.PoItem;
        console.log(poNumber);
        console.log(item);
      } catch (error) {
        self.$message({
          message: "无效的二维码",
          type: "error",
        });
        return;
      }

      let url = `${self.$_emApiMixin_entityBaseApi("sithMesInventoryReceiptReturnRecord")}/findAllByPoItemNumber?poNumber=${poNumber}&itemCode=${item}&type=101`;
      self.$_emApiMixin_get(url,{})
      .then(response => {
        if(response instanceof Array) {
          if(response.length === 0) {
            self.$message({
              message: "无101收货记录！",
              type: "error",
            });
          } else {
            self.receiveRecords = response.map(record => {
              if(typeof(record.returnQuantity) == "undefined") {
                record.returnQuantity = 0;
                return Object.assign(record,{currentReturn:record.receiptQuantity,currentReceive:record.receiptQuantity})
              } else {
                return Object.assign(record,{currentReturn:record.receiptQuantity-record.returnQuantity,currentReceive:record.receiptQuantity-record.returnQuantity});
              }
            })
          }

        }
      }).finally(() => {
          this.openScanner = false;
        });
    },
    confirmReceive(type) {
      let self = this;
      let _url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryItem")}/confirmReceive`;
      let requestBody = {};
      let ids;
      if(type === 'batch') {
        ids = self.selectIds;
      } else {
        ids = self.itemList.map(obj => {return obj.id}).join(",");
      }
      requestBody.idStr = ids;
      requestBody.receiveQuantity = self.quantityForm.receivedQuantity;
      self.$_emApiMixin_post(_url, requestBody)
        .then((request) => {
          if (request.status === 200) {
            self.$message({
              message: "确认收货成功！",
              type: "success",
            });
            self.$refs.emListFilter.doQuery();
          } else {
            self.$message({
              message: "确认收货失败！",
              type: "error",
            });
          }
        })
        .finally(() => {
          this.receiveDialogVisible = false;
          this.batchDialogVisible = false;
        });
    },
    confirmReturn() {
      let self = this;
      let _url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryItem")}/confirmReturn?poItemId=${this.itemList[0].id}`;
      self.$_emApiMixin_post(_url, {})
        .then((request) => {
          if (request.status === 200) {
            self.$message({
              message: "102退货成功！",
              type: "success",
            });
            self.$refs.emListFilter.doQuery();
          } else {
            self.$message({
              message: "102退货失败！",
              type: "error",
            });
          }
        })
        .finally(() => {
          this.returnDialogVisible = false;
        });
    },
    submit101Inspection() {
      let self = this;
      let ids = self.itemList.map(obj => {return obj.id}).join(",");
      let _url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryItem")}/submit101Inspection?ids=${ids}`;
      self.$_emApiMixin_post(_url, {})
        .then((request) => {
          if (request.status === 200) {
            self.$message({
              message: "发起质检成功！",
              type: "success",
            });
            self.$refs.emListFilter.doQuery();
          } else {
            self.$message({
              message: "发起质检失败！",
              type: "error",
            });
          }
        })
        .finally(() => {
          this.receiveDialogVisible = false;
        });
    },
    openBatchReceive() {
      let self = this;
      let _url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryItem")}/obtainItemsWithReceiptQuantity?ids=${self.selectIds}&type=101`;
      self.$_emApiMixin_post(_url, {})
        .then((response) => {
          if (response.status === 200) {
            self.itemList = response.data;
            self.batchDialogVisible = true;
          } else {
            self.$message({
              message: "查询失败",
              type: "error",
            });
          }
        })
    },
    clearQuantity() {
      this.quantityForm.receivedQuantity = '';
      this.receiveRecords = [];
    },
    openBatchReturn() {
      let self = this;
      let url = `${self.$_emApiMixin_entityBaseApi("sithMesInventoryReceiptReturnRecord")}/findAllByPoitemId?ids=${self.selectIds}&type=101`;
      self.$_emApiMixin_get(url,{})
      .then(response => {
        if(response instanceof Array) {
          if(response.length === 0) {
            self.$message({
              message: "无收货记录！",
              type: "error",
            });
          } else {
            self.receiveRecords = response.map(record => {
              if(typeof(record.returnQuantity) == "undefined") {
                record.returnQuantity = 0;
                return Object.assign(record,{currentReturn:record.receiptQuantity,currentReceive:record.receiptQuantity})
              } else {
                return Object.assign(record,{currentReturn:record.receiptQuantity-record.returnQuantity,currentReceive:record.receiptQuantity-record.returnQuantity});
              }
            })
            self.batchReturnDialogVisible = true;
          }

        }
      })

    },
    batchReturn102() {
      let self = this;
      let _url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryItem")}/batchReturn102`;
      let requestBody = {};
      requestBody.idStr = self.selectIds;
      requestBody.receiveQuantity = self.quantityForm.receivedQuantity;
      self.$_emApiMixin_post(_url, requestBody)
        .then((request) => {
          if (request.status === 200) {
            self.$message({
              message: "102退货成功！",
              type: "success",
            });
            self.$refs.emListFilter.doQuery();
          } else {
            self.$message({
              message: "102退货失败！",
              type: "error",
            });
          }
        })
        .finally(() => {
          this.batchReturnDialogVisible = false;
        });
    },
    handleSelect(selection) {
      this.recordsToReturn = selection;
    },
    batchReturn102New() {
      let self = this;
      let _url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryItem")}/batchReturn102New`;
      self.$_emApiMixin_post(_url, self.recordsToReturn)
        .then((request) => {
          if (request.status === 200) {
            self.$message({
              message: "102退货成功！",
              type: "success",
            });
            self.$refs.emListFilter.doQuery();
          } else {
            self.$message({
              message: "102退货失败！",
              type: "error",
            });
          }
        })
        .finally(() => {
          this.batchReturnDialogVisible = false;
        });
    },
    batchReceive101() {
      let self = this;
      let _url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryItem")}/batchReceive101`;
      self.$_emApiMixin_post(_url, self.itemList)
      .then((response) => {
          if (response.status === 200) {
            self.$message({
              message: "101收货成功！",
              type: "success",
            });
            self.$refs.emListFilter.doQuery();
          } else {
            self.$message({
              message: "101收货失败！",
              type: "error",
            });
          }
        })
        .finally(() => {
          this.batchDialogVisible = false;
        });
    },
    openScannerDialog() {
      this.openScanner = true;
      setTimeout(() => {
        this.$refs.scanner.openCamera('');
      },500);
    },
    // 获取紧急程度整数标识对应的描述
    getUrgencyName(type) {
      if(type) {
          switch(type) {
              case 0:
                  return '紧急'
              case 1:
                  return '一般'
          }
      }
    },
    // 获取免税标记整数标识对应的描述
    getTaxFlagName(type) {
      if(type) {
        switch(type) {
          case 0:
            return '免税'
          case 1:
            return '不免税'
        }
      }
    },
    createAbnormalArrivalProcess() {
      // let poItemId = this.itemList[0].id;
      let poItemId = this.selectIds;
      console.log("异常的物料：" + poItemId);
      this.$router.push(
        "/sithMes/inventory/sithMesInventoryAbnormalArrivalProcessEdit"
      );
      this.$store.commit(
        "sithMesInventoryAbnormalArrivalProcess/setNewEntity",
        {}
      );
      this.$store.commit(
        "sithMesInventoryAbnormalArrivalProcess/setCrudState",
        "edit"
      );
      this.$store.commit(
        "sithMesInventoryAbnormalArrivalProcess/setEntityAttribute",
        { key: "poItemId", newValue: poItemId }
      );
    },
  },
  mounted() {
    if (this.$route.query.hasOwnProperty('itemCode')) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('itemCodeFilter', this.$route.query.itemCode);
    }
    if (this.$route.query.hasOwnProperty('purchaseNumber')) {
            this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('purchaseNumberFilter', this.$route.query.poId);
    }
    this.$refs.emListFilter.doQuery();
  },

};
</script>
